import React, { useState } from "react";
import "./ViewReportsCEO.css";
import axios from "axios";
import ViewReportsCEOTable from "./ViewReportsCEOTable.jsx";
// import ViewReportsCEOForm from "./ViewReportsCEOForm.jsx";
import ViewReportsCEOFormEdit from "./ViewReportsCEOFormEdit.jsx";
export default function ViewReportsCEO(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [SelectedEmp, setSelectedEmp] = useState([]);
  const handleAddViewReportsCEO = () => {
    // // console.log("clicked1");
    setTable(false);
  };
  const handleEditViewReportsCEO = (e) => {
    console.log(e);
    // console.log("clicked6");

    setEditForm(true);
    setEditData(e);
  };
  const handleFormClose = () => {
    // // console.log("clicked1");
    setTable(true);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");

    setEditForm(false);
  };

  const handleViewReportsCEOEditUpdate = (info, newInfo, id) => {
    newInfo.preventDefault();

    let body = {
      Status: newInfo.target[4].value,
    };
    console.log("update", body);
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-report-ceo/" +
          id,
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
    setEditForm(false);
  };

  return (
    <React.Fragment>
      {table ? (
        editForm ? (
          <ViewReportsCEOFormEdit
            onViewReportsCEOEditUpdate={handleViewReportsCEOEditUpdate}
            onFormEditClose={handleEditFormClose}
            editData={editData}
          />
        ) : (
          <ViewReportsCEOTable
            onAddViewReportsCEO={handleAddViewReportsCEO}
            onEditViewReportsCEO={handleEditViewReportsCEO}
            data={props.data}
            SelectedEmp={SelectedEmp}
            setSelectedEmp={setSelectedEmp}
          />
        )
      ) : (
        <div></div>
      )}
    </React.Fragment>
  );
}
